import type { FaireProductEntity } from "../../entity_types/product";

export const p_q6cv5bju49: FaireProductEntity = {
  token: "p_q6cv5bju49",
  type: "product",
  name: "Liver Tonic Herbal Supplement Capsules 120 Capsules",
  brandToken: "b_3z46kjdoak",
  brandName: "Plant Therapy",
  imageUrl:
    "https://cdn.faire.com/fastly/871f4e8ef659b9b7a41c7648f5e899dc8e2f21a3c870ad71e54a70c9bd34863b.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0c53f24420388575831507907f99492aa9270c9b8ffa2e4877948f4d3dc0041e.webp",
    "https://cdn.faire.com/fastly/0b1bdbf6de7df606c48734675383230ff335a9b11cc195e4d9e696c51887d614.webp",
    "https://cdn.faire.com/fastly/6b823ad26abce9d367b94a9cf15e57da75d2cb7a42d6d1720e59da39ca6c9a29.jpeg",
    "https://cdn.faire.com/fastly/091207f1811a3d869122c127da669d98a724b40f14653c55fda98886b5e20b0c.jpeg",
    "https://cdn.faire.com/fastly/ddbe016e8c901b437eeffbbf0407caffcbe325cf85643772cb6aba3725c0544e.jpeg",
    "https://cdn.faire.com/fastly/d2621886c2f775b71ea8d7f394e09e9807020a9301b350ac31ec0588d8499678.webp",
    "https://cdn.faire.com/fastly/14fa033bc18e81e0a47dbbeac8e409f2e87a3e6aef9b615025fdbfe1044f528a.jpeg",
  ],
  priceDollars: 20,
  description:
    "Give your liver some love with our Liver Tonic supplement, a simple and easy way to keep your liver in tip-top shape — because when your liver’s feeling good, so are you! This incredible organ is like your body’s detox factory, taking out toxins, turning nutrients into energy, breaking down fat, and keeping an eye on whole-body balance. Our Liver Tonic packs a punch with everything your liver craves for stellar performance: Milk Thistle for antioxidant armor and cell repair; Turmeric to improve digestion; Dandelion, the natural cleanse champ that flushes out the baddies; and Black Pepper to boost the uptake of these mighty ingredients and fortify liver defenses.* \n\nElevate your everyday with our Liver Tonic supplement, where natural ingredients meet rigorous testing and vegetarian capsules, making the perfect complement to your healthy lifestyle to help your body feel its best every day.",
  tags: [],
  msrpDollars: 39.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:02.054Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
